import {getCountersHistogram, clearTimingMetrics} from './timingMetrics';

let perfMetricsEnabled = false;

export const collectMetrics = (options = {}) => {
	const {shouldClear = false, shouldDisable = false} = options;

	// Disable metric collection if needed
	if (shouldDisable) perfMetricsEnabled = false;

	// Collect metrics
	const counters = getCounters();

	// Clear metric collection objects if needed
	if (shouldClear) clearPerfMetrics();
	return {counters};
};

const getCounters = () => {
	return getCountersHistogram();
};

export const enable = () => {
	perfMetricsEnabled = true;
};

export const isPerfMetricsEnabled = () => {
	return perfMetricsEnabled;
};

export const clearPerfMetrics = () => {
	clearTimingMetrics();
};
